// extracted by mini-css-extract-plugin
export default {"container":"ComingSoon_container__nUbaA","static-container":"ComingSoon_static-container__WTF68"};